module.exports = __webpack_public_path__ + "static/media/WBN_WBNB2B_WORLDWIDE_NETWORK.fcf6f67f.png";